import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getStepUrlPaths } from '../utilities/utils';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

const accessiblePaths = new Set('add-case-information');

export function useFormStepNavigation() {
  const { step, type } = useParams();
  const navigate = useNavigate();

  const directMailingType = useSelector((state: RootState) => state.upload.formData.directMailingType);

  const stepPaths = getStepUrlPaths(directMailingType, type);

  const currentIndex = stepPaths.indexOf(step as string);

  useEffect(() => {
    if (!stepPaths.includes(step as string) || !accessiblePaths.has(step as string)) {
      navigate(`/create-notice/${type}/${stepPaths[0]}`, { replace: true });
    }
  }, [step]);

  const goNext = () => {
    if (currentIndex < stepPaths.length - 1) {
      const nextStep = stepPaths[currentIndex + 1];
      accessiblePaths.add(nextStep);
      navigate(`/create-notice/${type}/${nextStep}`);
    }
  };

  const goBack = () => {
    if (currentIndex > 0) {
      const prevStep = stepPaths[currentIndex - 1];
      navigate(`/create-notice/${type}/${prevStep}`);
    }
  };

  const navigateToIndex = (index: number) => {
    navigate(`/create-notice/${type}/${stepPaths[index]}`);
  };

  return {
    stepPaths,
    currentIndex,
    currentStep: stepPaths[currentIndex],
    accessiblePaths,
    navigateToIndex,
    goNext,
    goBack,
  };
}
